import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AuditList from './AuditList';
import AuditExecutor from './AuditExecutor';
import AuditDetail from './AuditDetail';
import AuditReview from './AuditReview';

const Audits: React.FC = () => {
  return (
    <Routes>
      <Route index element={<AuditList />} />
      <Route path=":id" element={<AuditDetail />} />
      <Route path=":id/execute" element={<AuditExecutor />} />
      <Route path=":id/review" element={<AuditReview />} />
    </Routes>
  );
};

export default Audits;